import { useEffect } from 'react';

import { FEATURE_FLAGS } from '~common';
import { WelcomeBack } from '~components/organisms';
import { RENTAL_PAGE_PATH } from '~configs';
import { useNavigateInApp } from '~hooks';
import { checkEnabledFeatureFlag } from '~utils';

export const WelcomeBackPage = () => {
  const enableNewPaymentFlow = checkEnabledFeatureFlag(
    FEATURE_FLAGS.NEW_WEB_APP_PAYMENT_FLOW,
  );
  const navigate = useNavigateInApp();

  useEffect(() => {
    if (enableNewPaymentFlow) {
      navigate(RENTAL_PAGE_PATH);
    }
  }, [enableNewPaymentFlow, navigate]);

  if (enableNewPaymentFlow) {
    return null;
  }

  return <WelcomeBack />;
};
